import home from './home.json';
import address from './address.json';
import messageRequest from './message-request.json';
import common from './common.json';
import store from './store.json';
import payment from './payment.json';
import panther from './panther.json';
import promotion from './promotion.json';
import event from './event.json';
import categories from './categories.json';
import alert from './alert.json';

export default {
  home,
  address,
  messageRequest,
  common,
  store,
  payment,
  panther,
  promotion,
  event,
  categories,
  alert,
};
